import React from 'react';

import { Group, Text } from '@mantine/core';

interface TableHeaderProps {
  trackedCount: number;
  athleteCount: number;
  completedCount: number;
  filterMenu?: React.ReactNode;
  leaderboardToggle?: React.ReactNode;
}

const TableHeader = ({
  trackedCount,
  athleteCount,
  completedCount,
  filterMenu,
  leaderboardToggle,
}: TableHeaderProps): JSX.Element => (
  <Group
    position='apart'
    align='center'
    px='md'
    py='sm'
    sx={theme => ({
      border: `1px solid ${theme.colors.gray[2]}`,
      borderRadius: theme.radius.sm,
    })}
  >
    <Text size='sm' color='dimmed'>
      Tracking results for {trackedCount} movement{trackedCount !== 1 ? 's' : ''}
    </Text>
    <Group spacing='sm'>
      <Text size='sm' weight={700}>
        {completedCount} / {athleteCount}
      </Text>
      <Text size='xs' color='dimmed'>
        Athletes logged
      </Text>
      {filterMenu}
      {leaderboardToggle}
    </Group>
  </Group>
);

export default TableHeader;
